import React from "react";
import Footer from "./Footer";

const Index = ({ children }) => {
  return (
    <>

      {children}
      {localStorage.getItem("portal") === "new_app" ? <></> : <Footer />}
    </>
  );
};

export default Index;
